/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
// eslint-disable-next-line no-use-before-define

import { Form, Input, Popover, Select, Space } from 'antd';
import { RolesEnum } from 'core/models';
import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { ApplicationState } from 'store/combineReducers';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { config } from 'core/config';

const { patients, reports } = config.paths;

export default function SearchField(): ReactElement {
  const { t } = useTranslation();
  const history: History = useHistory();
  const { isAuth, user, siteList } = useSelector(
    (state: ApplicationState) => state.session,
  );
  const [form] = Form.useForm();

  const onFinish = () => {
    form.validateFields().then((values) => {
      if (values.keyword === '') {
        values.keyword = undefined;
      }
      history.push(`${values.type}`, values);
    });
  };

  return (
    <Popover
      trigger={['click']}
      content={
        <div className="search-form">
          <Form
            form={form}
            layout="inline"
            onFinish={() => onFinish()}
            className="topSearchForm"
          >
            <Space.Compact>
              <Form.Item
                name="type"
                rules={[{ required: true }]}
                style={{ flex: 1, marginRight: 0, width: 150 }}
              >
                <Select
                  placeholder={t('layoutHeader.form.type.placeholder')}
                  allowClear
                >
                  <Select.Option value={patients}>
                    {t('layoutHeader.form.type.options.patients')}
                  </Select.Option>
                  <Select.Option value={reports}>
                    {t('layoutHeader.form.type.options.Reports')}
                  </Select.Option>
                  {/* <Select.Option value="patients/ecg-record">
                    {t('layoutHeader.form.type.options.ecgRecord')}
                  </Select.Option> */}
                </Select>
              </Form.Item>
              <Form.Item name="keyword" style={{ flex: 2 }}>
                <Input.Search
                  onSearch={() => onFinish()}
                  width={200}
                  // onChange={(e) => setKeyword(e.target.value)}
                  onPressEnter={() => onFinish()}
                  allowClear
                  enterButton
                  placeholder={t('layoutHeader.form.keyword.placeholder')}
                />
              </Form.Item>
            </Space.Compact>
          </Form>
        </div>
      }
    >
      <span
        style={{
          marginRight: 16,
          fontSize: 20,
        }}
      >
        <SearchOutlined />
      </span>
    </Popover>
  );
}
